import { Card, Col, Row } from 'react-bootstrap'
import { BsCircleFill } from 'react-icons/bs'
import { PIM_EMP_PROPERTY_ASS } from '../../../../router/routes'
import { useNavigate, useParams } from 'react-router-dom'
import { Image } from 'react-bootstrap'
import Macbook from '../../../../images/Property-Info/Macbook.svg'

function PropertyInfo() {
  const navigate = useNavigate()
  const { id } = useParams()

  const getLinkQuery = (url) => {
    return `${url}/${id}`
  }
  const welfare = [
    {
      id: 1,
      img: Macbook,
      color: '#23B74C',
      title: 'Assets',
      status: 'ข้อมูลถือครองอุปกรณ์ไอที',
      url: getLinkQuery(PIM_EMP_PROPERTY_ASS)
    }
    // {
    //   id: 2,
    //   img: Cards,
    //   color: '#23B74C',
    //   title: 'บัตรพนักงาน',
    //   status: 'ได้รับเรียบร้อยแล้ว',
    //   url: '#'
    // },
    // {
    //   id: 3,
    //   img: MedicalCard,
    //   color: '#C4212C',
    //   title: 'บัตรประกันสุขภาพ',
    //   status: 'ยังไม่ได้รับ',
    //   url: '#'
    // },
    // {
    //   id: 4,
    //   img: Airport,
    //   color: '#C4212C',
    //   title: 'บัตรเข้าออกท่าอากาศยาน',
    //   status: 'ยังไม่ได้รับ',
    //   url: '#'
    // },
    // {
    //   id: 5,
    //   img: Tshirt,
    //   color: '#23B74C',
    //   title: 'เสื้อ',
    //   status: 'ได้รับเรียบร้อยแล้ว',
    //   url: '#'
    // },
    // {
    //   id: 6,
    //   img: Uniform,
    //   color: '#23B74C',
    //   title: 'Uniform',
    //   status: 'ได้รับเรียบร้อยแล้ว',
    //   url: '#'
    // },
    // {
    //   id: 6,
    //   img: Document,
    //   color: '#23B74C',
    //   title: 'อื่น ๆ',
    //   status: 'ได้รับเรียบร้อยแล้ว',
    //   url: '#'
    // }
  ]

  return (
    <>
      <Card.Body className="overflow-auto">
        <Row>
          {welfare.map((d, i) => (
            <Col xl={4} className="mb-4">
              <Card
                className="cursor-pointer"
                border="0"
                style={{
                  backgroundColor: '#EEF4FF',
                  // margin: "auto",
                  height: 100
                }}
                onClick={() => navigate(d.url)}
              >
                <Card.Body>
                  <Row>
                    <Col xl={2}>
                      <Image
                        src={d.img}
                        className="me-3"
                        style={{
                          height: '40px',
                          width: '40px'
                        }}
                      ></Image>
                    </Col>
                    <Col xl={10}>
                      <p className="my-auto align-items-center ">{d.title}</p>
                      <div className="bottom m-0 d-flex justify-content-between">
                        <label className="mb-0 fw-light mt-1 small">
                          <BsCircleFill style={{ color: d.color }} /> {d.status}
                        </label>
                        {/* <label className="mb-0 fw-light mt-1 small">
                        <BsCalendar /> 01 Sep 2021
                      </label> */}
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </>
  )
}

export default PropertyInfo
